import { render, staticRenderFns } from "./kot-receipt-label.vue?vue&type=template&id=9fd053d8"
import script from "./kot-receipt-label.vue?vue&type=script&lang=js"
export * from "./kot-receipt-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports